var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "contentBox"
  }, _vm._l(_vm.btnList, function (item) {
    return _c('div', {
      key: item,
      staticClass: "btnLi",
      on: {
        "click": function ($event) {
          return _vm.jumpPage(item);
        }
      }
    }, [_vm._v(" " + _vm._s(item) + " ")]);
  }), 0), _c('newDailog', {
    attrs: {
      "info": _vm.popupInfo,
      "program": _vm.program
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };